module.exports = __webpack_public_path__ + "img/OBUNoOrder_05.f9aac5a8.png";